import React, { useState } from 'react';
import { Checkin, Outcome } from 'types';
import CheckinTimelineBlock from './CheckinTimelineBlock';
import KoalaButton from 'koala/components/Button';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import theme from 'theme';

interface Props {
  outcome: Outcome;
  checkins: Checkin[];
}

const Container = styled.div`
  padding: ${theme.spacing.x1} 0;
`;

const ExpandTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.x1};
  padding: ${theme.spacing.x1};
`;

function Timeline(props: Props) {
  const { outcome, checkins } = props;
  const { t } = useTranslation();
  const translationKey = 'panels.outcome';

  const [showExpanded, setShowExpanded] = useState(false);
  const checkinsAboveExpand = checkins.slice(0, 5);
  const checkinsBelowExpand = checkins.slice(5);

  return (
    <Container>
      {checkinsAboveExpand.map((checkin) => {
        return <CheckinTimelineBlock checkin={checkin} outcome={outcome} />;
      })}
      {checkinsBelowExpand.length > 0 && (
        <>
          {!showExpanded && (
            <ExpandTitle>
              <KoalaButton appearance="secondary" onClick={() => setShowExpanded(!showExpanded)}>
                {t(`${translationKey}.morePreviousCheckins`, { count: checkinsBelowExpand.length })}
              </KoalaButton>
            </ExpandTitle>
          )}
          {showExpanded && (
            <>
              {checkinsBelowExpand.map((checkin, i) => {
                return <CheckinTimelineBlock outcome={outcome} checkin={checkin} key={checkin.id} />;
              })}
            </>
          )}
        </>
      )}
    </Container>
  );
}

export default Timeline;
